<template>
  <div>
    <!--pages/deleteorder/deleteorder.wxml-->
    <!-- <div class='error-view' hidden='{{toptipsHidden}}' bindtap='cancelTips'>
    <image class='tips-logo' src='../../image/tips.svg'></image>
    <div class='error-tips'>{{toptipsText}}</div>
    <image class='cancel-logo' src='../../image/cancel.svg'></image>
</div> -->

    <div class="del">
      <!-- 阅读须知 -->
      <div class="deltipinfo text-center" v-if="deltipinfo">
        <!-- 标题 -->
        <div class="font-title">删除订单告知书</div>
        <!-- 内容 -->
        <div class="text-left">
          <span>
            {{ deltip }}
          </span>
        </div>
        <!-- 阅读须知选择 -->
        <div class="checkbtn text-left mar-top mar-bto">
          <van-checkbox
            class="check-agree"
            @change="checkboxChange"
            v-model="checked"
            shape="square"
            :disabled="isCheckDisabled"
            checked-color="#1aad19"
            v-if="isShowAgree"
          >
            阅读并同意</van-checkbox
          >
          <!-- <checkbox-group bindchange="bindAgreeChange">
            <label>
              <div class="weui-agree__text">
                <label class="checkbox">
                  <checkbox v-model="ok" />我已阅读并知晓
                </label>
              </div>
            </label>
          </checkbox-group> -->
        </div>
        <!-- 按钮 -->
        <div>
          <van-button
            type="primary"
            color="#1aad19"
            class="mar-topbig"
            @click="agreeButton"
            block
            :disabled="disabled"
            >同意</van-button
          >
        </div>
      </div>

      <!-- 身份核验 -->
      <div v-if="Identitycheck" class="Identitycheck">
        <!-- 身份核验 -->
        <div>
          <div class="text-center font-title">身份核验</div>
          <div>
            <span class="colorred">
              注意： 请如实进行验证 如验证失败将会影响到您的订单删除
            </span>
          </div>
        </div>
        <!-- 请选择 -->
        <div class="selechecktip">
          <div class="font-subtitle mar-top mar-bto">请选择</div>
          <div>
            <div>一下哪个售价或为您在办理业务中曾使用过的手机号</div>
            <div class="mar-bto">
              <div class="page-section">
                <div class="weui-cells weui-cells_after-title">
                  <van-radio-group
                    v-model="radio2"
                    direction="horizontal"
                    v-for="(item, index) in items"
                    :key="'bingli' + index"
                  >
                    <van-radio
                      :name="index"
                      @click="radioChange(item, index)"
                      checked-color="#1aad19"
                      >{{ item.name }}</van-radio
                    >
                  </van-radio-group>
                </div>
              </div>
            </div>
            <div class="mar-top">
              <van-button
                type="primary"
                class="mar-topbig"
                color="#1aad19"
                @click="confirm"
                block
                >确定</van-button
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 删除后的联系方式填写 -->
      <div v-if="ContactInfo">
        <div class="font-subtitle mar-bto">请填写</div>
        <div class="colorred">
          为保护您的账户信息安全，我们的客服人员将再收到您删除订单要求后第一时间与您取得联系与您进
          行核实，请填写您的联系方式，以免因无法与您核实导致您删除订单失败
        </div>
        <div class="mar-bto mar-top">
          <!-- 联系人姓名 -->
          <div class="page-section">
            <div class="weui-cells__title">联系人姓名</div>
            <div class="weui-cells weui-cells_after-title">
              <div class="weui-cell weui-cell_input borderline">
                <input
                  class="weui-input"
                  auto-focus
                  placeholder="请输入联系人姓名"
                  v-model="Name"
                  bindinput="bindNameInput"
                />
              </div>
            </div>
          </div>
          <!-- 联系人电话 -->
          <div class="page-section">
            <div class="weui-cells__title">联系人电话</div>
            <div class="weui-cells weui-cells_after-title">
              <div class="weui-cell weui-cell_input borderline">
                <input
                  class="weui-input"
                  bindinput="bindtelInput"
                  v-model="tel"
                  placeholder="请输入联系人电话"
                />
              </div>
            </div>
          </div>
          <!-- 联系人邮箱 -->
          <div class="page-section">
            <div class="weui-cells__title">联系人邮箱</div>
            <div class="weui-cells weui-cells_after-title">
              <div class="weui-cell weui-cell_input borderline">
                <input
                  class="weui-input"
                  bindinput="bindemailInput"
                  v-model="email"
                  placeholder="请输入联系人邮箱"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 提交 -->
        <div class="mar-topbig">
          <van-button type="primary" color="#1aad19" @click="subbmit" block
            >提交</van-button
          >
        </div>
      </div>

      <!-- 提交后提示 -->
      <div v-if="success" class="success">
        <div>
          <div>
            <img src="../assets/rightok.png" class="successimg" />
          </div>
          <div class="text-center">提交成功</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Button, Checkbox, Notify, RadioGroup, Radio, Dialog } from "vant";
Vue.use(Button)
  .use(RadioGroup)
  .use(Radio)
  .use(Checkbox)
  .use(Dialog)
  .use(Notify);
export default {
  name: "guide",
  data() {
    return {
      radio2: "",
      checked: false,
      isShowAgree: true,
      isCheckDisabled: false,
      toptipsHidden: true,
      toptipsText: "",
      disabled: true,
      deltipinfo: true,
      agree: "1",
      Identitycheck: false,
      checkNum: "22",
      selcheckNum: "",
      success: false,
      Name: "",
      tel: "",
      email: "",
      items: [
        { value: "11", name: "11111111111" },
        { value: "33", name: "33333333333" },
        { value: "22", name: "22222222222" },
        { value: "44", name: "44444444444" },
      ],
      ContactInfo: false,
      deltip:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio.",
    };
  },
  methods: {
    checkboxChange(e) {
      console.log(e);
      if (e == false) {
        this.checked = false;
        this.disabled = true;
      } else {
        this.checked = true;
        this.disabled = false;
      }
    },
    // 阅读并知晓同意按钮
    agreeButton() {
      this.deltipinfo = false;
      this.Identitycheck = true;
    },
    // 身份验证选择
    radioChange(item) {
      console.log(item);
      // console.log('radio发生change事件，携带value值为：', e.detail.value)

      const items = this.items;
      for (let i = 0, len = items.length; i < len; ++i) {
        items[i].checked = items[i].value === item.value;
      }

      // this.setData({
      (this.items = items), (this.selcheckNum = item.value);
      // })
    },

    // 选择后确定按钮
    confirm: function () {
      if (this.selcheckNum == this.checkNum) {
        console.log("通过");
        this.ContactInfo = true;
        this.Identitycheck = false;
      } else {
        console.log("验证失败");
        Dialog.confirm({
          title: "提示",
          message: "验证失败",
          confirmButtonText: "再次尝试",
          cancelButtonText: "不删了",
        })
          .then(() => {
            // on confirm
          })
          .catch(() => {
            this.$router.push("/apply-list");
            // on cancel
          });
      }
    },
    subbmit: function () {
      console.log("000");
      console.log(this.$util.checkUserName(this.Name));
      if (this.$util.trim(this.Name).length >= 20) {
        Notify({
          type: "warning",
          message: "您输入的姓名超过20位",
        });
        return;
      }
      if (this.$util.trim(this.Name).length == 0) {
        Notify({
          type: "warning",
          message: "请输入姓名",
        });
        return;
      }
      let reg = /^1[0-9]{10}$/.test(this.$util.trim(this.tel));
      if (reg == false) {
        Notify({
          type: "warning",
          message: "请输入正确的手机号码",
        });
        return;
      }
      let str =
        /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
          this.$util.trim(this.email)
        );
      console.log(str);
      console.log("pdlspd", this.email);

      if (str == false) {
        Notify({
          type: "warning",
          message: "请输入正确的填写邮箱",
        });
        return;
      }

      this.ContactInfo = false;
      this.success = true;
    },
  },
};
</script>
<style>
/* pages/deleteorder/deleteorder.wxss */
.delorderbutton {
  width: 90px;
  margin: 40px auto;
  font-size: small;
  color: #2fb42e;
}
.del {
  background-color: rgb(255, 255, 255);
  padding: 20px 20px;
  height: 100vh;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.font-title {
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 20px;
}
.font-subtitle {
  font-size: 18px;
  font-weight: bold;
}
.mar-top {
  margin-top: 20px;
}
.mar-bto {
  margin-bottom: 20px;
}
.mar-topbig {
  margin-top: 60px;
}
.colorblack {
  color: #333333;
}
.colorred {
  color: red;
}
.borderline {
  border: 1px solid #c4c4c4;
  border-radius: 5px;
}
.deltipinfo {
  /* text-align: center; */
}
.checkbtn {
  /* text-align: left; */
}
.selechecktip {
  margin-top: 20px;
  border-top: 10px solid #f1f1f1;
}
.Identitycheck {
  background-color: white;
}
.success {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 200px;
}
.successimg {
  width: 80px;
  height: 80px;
}
.error-view {
  top: 0;
}
.weui-cell {
  padding: 10px 16px;
}
.van-radio-group {
  margin: 10px;
}
.van-checkbox__label {
  color: #2fb42e;
}
</style>